import React, { useMemo } from "react";

import { Language, Order } from "../../../../../../../services";
import { ColumnId } from "../../columns";
import { CellContentRoot } from "..";

import cellProcessing from "./cellProcessing";

const TransferFromTaxiServiceCellContent: React.FC<
	TransferFromTaxiServiceCellContent.Props
> = ({ item, language }) => {
	const { content, backgroundColor, textColor } = useMemo(() => {
		const isCellsReady = !!item?.cellsForTableSettings?.isCellsReady;

		const isLanguageMatched =
			item?.cellsForTableSettings?.lang === language;

		if (
			item.isOwn &&
			item.additionalFields?.transfer?.sendProcess
				?.currentTransferStage === null
		) {
			return "";
		}

		const preparedCell =
			item?.cellsForTable?.[ColumnId.TransferFromTaxiService];

		if (isCellsReady && isLanguageMatched && preparedCell != null) {
			return preparedCell;
		}

		return cellProcessing(item, language);
	}, [item, language]);

	return (
		<CellContentRoot
			alignItems="center"
			h="100%"
			w="100%"
			backgroundColor={backgroundColor}
			textColor={textColor}
		>
			{content}
		</CellContentRoot>
	);
};

declare namespace TransferFromTaxiServiceCellContent {
	interface Props {
		item: Order.Model;

		language: Language;
	}
}

export default TransferFromTaxiServiceCellContent;
